import { useEffect, useState } from 'react';

/**
 * True on tablet and up (the breakpoint where the auth pages show the guide
 * character beside the form). Those screens route messages through the
 * character instead of a toast; phones keep the toast, since the character
 * is small there and easy to miss.
 */
export const useIsWideScreen = (query = '(min-width: 992px)') => {
    const [matches, setMatches] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches
    );

    useEffect(() => {
        const media = window.matchMedia(query);
        const update = () => setMatches(media.matches);

        update();
        media.addEventListener('change', update);
        return () => media.removeEventListener('change', update);
    }, [query]);

    return matches;
};

export default useIsWideScreen;
